import type { CustomerSettings, Picklist, PicklistOption, PriorityMap } from '@/hooks/usePsa.ts';

/** One of the PSA's lists by its field name, empty when the PSA has no such list. */
export function picklistOptions(picklists: Picklist[] | undefined, field: string): PicklistOption[] {
  return picklists?.find((p) => p.field.toLowerCase() === field.toLowerCase())?.options ?? [];
}

/** The severities a priority is chosen for; `info` takes `low`'s. */
export const SEVERITIES: { key: keyof PriorityMap; label: string }[] = [
  { key: 'critical', label: 'Critical' },
  { key: 'high', label: 'High' },
  { key: 'medium', label: 'Medium' },
  { key: 'low', label: 'Low (and info)' },
];

/** What each customer setting is called, in the order a summary lists them. */
const CUSTOMER_SETTING_NAMES: [keyof CustomerSettings, string][] = [
  ['queue_id', 'queue'],
  ['ticket_category_id', 'category'],
  ['tickettype_id', 'ticket type'],
  ['ticket_type', 'ticket type'],
  ['source_id', 'source'],
  ['issue_type', 'issue type'],
  ['team_id', 'team'],
  ['agent_id', 'agent'],
  ['due_in_hours', 'due time'],
  ['priority_map', 'priorities'],
  ['location_id', 'location'],
  ['contract_id', 'contract'],
  ['site_id', 'site'],
];

/** "queue, priorities": what a customer sets for itself, or null when it sets nothing. */
export function customerSettingsSummary(settings: CustomerSettings | null | undefined): string | null {
  if (!settings) return null;
  const set = CUSTOMER_SETTING_NAMES.filter(([key]) => {
    const value = settings[key];
    return value != null && (typeof value !== 'object' || Object.keys(value).length > 0);
  }).map(([, name]) => name);
  return set.length > 0 ? set.join(', ') : null;
}
